import appStore from "store";
import api from "./api";
import { runBatchSpeedTest } from "./speedTest";

const store = {
  namespaced: true,
  state: {
    codelist: [],
    urllist: [],
    updatePosterDialog: false,
    totalCount: 0,
    speedTestType: "inspectsurvival",
    speedResultMap: {},
    speedTesting: false,
  },
  getters: {
    filterList: (state) => state.codelist,
  },
  mutations: {
    setcodelist(state, payload) {
      state.codelist = payload;
    },
    seturllist(state, payload) {
      state.urllist = payload;
    },

    setupdatePosterDialog(state, payload) {
      state.updatePosterDialog = payload;
    },
    setTotalCount(state, payload) {
      state.totalCount = payload;
    },
    setSpeedTestType(state, payload) {
      state.speedTestType = payload;
    },
    setSpeedTesting(state, payload) {
      state.speedTesting = payload;
    },
    setSpeedResultMap(state, payload) {
      state.speedResultMap = payload;
    },
    patchSpeedResult(state, { id, result }) {
      state.speedResultMap = {
        ...state.speedResultMap,
        [id]: result,
      };
    },
    markSpeedResultsLoading(state, ids) {
      const map = { ...state.speedResultMap };
      ids.forEach((id) => {
        map[id] = { loading: true };
      });
      state.speedResultMap = map;
    },
  },
  actions: {
    async getUrlList({ commit, dispatch }, params) {
      const res = await api.getUrlList(params);
      commit("seturllist", res.data.list);
      commit("setTotalCount", res.data.totalCount);
      await dispatch("runBatchSpeedTest");
      return res;
    },

    async runBatchSpeedTest({ commit, state }) {
      const list = state.urllist || [];
      if (!list.length) {
        commit("setSpeedResultMap", {});
        commit("setSpeedTesting", false);
        return;
      }

      commit("setSpeedTesting", true);
      commit(
        "markSpeedResultsLoading",
        list.map((row) => row.id)
      );

      const results = await runBatchSpeedTest(list, state.speedTestType);
      results.forEach(({ id, result }) => {
        commit("patchSpeedResult", { id, result });
      });
      commit("setSpeedTesting", false);
    },

    async delOne({ commit }, id) {
      const res = await api.delOne(id);
      return res;
    },
    async addOne({ commit }, data) {
      const res = await api.addOne(data);
      return res;
    },
    async updateOne({ commit }, data) {
      const res = await api.updateUrl(data);
      return res;
    },
  },
};

appStore.registerModule("appLineUrl", store);
